import request from '@/api/index'

// 登录
export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

// 登录
export function userInfos(data) {
  return request({
    url: '/admin/getUserInfo',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js